export enum EnumTongHaoStatus {
  Recommend = '-1',
  InkLightUpLife = '0',
  GoodHomework = '1',
  StudyInsight = '2',
  BackToHoushan = '3',
  SnackTime = '4',
  XuantongGathering = '5',
  ClassmateGathering = '6',
  ClassmateWork = '7'
}

export enum EnumTongHaoOtherStatus {
  Follow = '0',
  Recommend = '1'
}
